'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxPrimitive } from '#pplx/frontend/aether/primitives/BoxPrimitive/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import React from 'react';
/**
 * Asset types that represent text-based documents and should render a
 * text-snippet thumbnail instead of a generic file icon.
 */
// intentionally broader than the backend's PREVIEW_TEXT_ELIGIBLE_TYPES
// (which only extracts text for CODE_FILE, RESEARCH_REPORT, DOC_FILE).
// DOCX_FILE and PDF_FILE are included so the frontend already recognizes
// them when backend extraction is added. Until then, preview_text_content
// is null for those types and AssetCardPreview falls through to the
// generic file icon (TextDocumentPreview requires truthy content).
/**
 * Renders a text-document thumbnail for asset cards by displaying a snippet
 * of the actual document content. The text overflows the preview area and is
 * clipped, giving a visual hint of the document.
 */
export const TextDocumentPreview = React.memo(function TextDocumentPreview({ previewTextContent, textClassName }) {
    return (_jsxs("div", { className: "relative size-full", children: [_jsx("div", { className: "absolute inset-0 bg-subtle opacity-20 dark:bg-base" }), _jsx(BoxPrimitive, { display: "flex", direction: "col", className: "relative size-full overflow-hidden px-4 pt-4 [mask-image:linear-gradient(to_bottom,black_60%,transparent)]", children: _jsx(TextPrimitive, { variant: "micro", family: "serif", color: "light", leading: "relaxed", textAlign: "start", className: textClassName ?? 'overflow-hidden', children: previewTextContent }) })] }));
});
//# sourceMappingURL=TextDocumentPreview.js.map